import { atomWithStorage } from 'jotai/utils';

export const movementsArrayAtom = atomWithStorage('movementsArray', []);
